import {
  ConsolidationOrderFields,
  OrderType,
} from '@returnmates/client-core/src/graphql/generated/api'

export const SORT_DIRECTION_MAP = {
  asc: OrderType.ASC,
  desc: OrderType.DESC,
}

export const SORT_FIELDS_MAP = {
  tracking: ConsolidationOrderFields.TRACKING,
  status: ConsolidationOrderFields.STATUS,
  destination: ConsolidationOrderFields.ADDRESS,
  partnerName: ConsolidationOrderFields.PARTNER,
  date: ConsolidationOrderFields.CREATED_AT,
  expectedDeliveryDate: ConsolidationOrderFields.EXPECTED_DATE,
  id: ConsolidationOrderFields.ID,
  weight: ConsolidationOrderFields.WEIGHT,
  carrierName: ConsolidationOrderFields.CARRIER,
  locationName: ConsolidationOrderFields.LOCATION_NAME,
}

export const DEFAULT_SORT = { columnName: 'status', direction: 'asc' as const }
